<template>
    <div class="ui-list">
        <slot></slot>
    </div>
</template>

<script>
export default {
    name: 'ui-list',

}

</script>

<style lang="scss" scoped>
    .ui-list {
        margin: auto;
        padding: 0 var(--padding) var(--padding);
        display: flex;
        flex-wrap: wrap;
        min-height: 20rem;

        .post-item {
            width: 25%;
        }
    }

    @media only screen and (max-width: 767px) {
        .ui-list {

            .post-item {
                width: 50%;
            }
        }
    }
</style>